export const PAGINATION_WIDTH = 8;

export function getStartPage(currentPageNumber: number, totalPages: number) {
  let startPage = currentPageNumber - PAGINATION_WIDTH;
  if (startPage > totalPages) {
    startPage = totalPages - PAGINATION_WIDTH;
  }
  if (startPage < 1) {
    startPage = 1;
  }

  return startPage;
}

export function getEndPage(currentPageNumber: number, totalPages: number) {
  let endPage = currentPageNumber + PAGINATION_WIDTH;
  if (endPage > totalPages) {
    endPage = totalPages;
  }

  return endPage;
}

export function getPageList(currentPageNumber: number, totalPages: number): number[] {
  const startPage = getStartPage(currentPageNumber, totalPages);
  const endPage = getEndPage(currentPageNumber, totalPages);
  const pageList = Array.from(Array(endPage - startPage + 1), (_, index) => index + startPage);
  if (pageList[0] !== 1) {
    pageList.splice(0, 0, 1);
  }

  return pageList;
}
